import { render, staticRenderFns } from "./ItemBatchGroupAssignment.vue?vue&type=template&id=15d0a659&scoped=true&"
import script from "./ItemBatchGroupAssignment.vue?vue&type=script&lang=js&"
export * from "./ItemBatchGroupAssignment.vue?vue&type=script&lang=js&"
import style0 from "./ItemBatchGroupAssignment.vue?vue&type=style&index=0&id=15d0a659&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d0a659",
  null
  
)

export default component.exports